<template>
	<ControlTowerDashboard v-if="project === PROJECTS.INTELLI_CONTROL_TOWER" />
	<CrossDockDashboard v-else />
</template>

<script>

import CrossDockDashboard from "./welcome.vue"
import ControlTowerDashboard from "./controlTower/Dashboard.vue"
import { getLoggedInUser, getUsersProject, PROJECTS, DEFAULT_PROJECT } from "../constants/role.js"
export default {
	name: "Dashboard",
	data() {
		return {
			project: DEFAULT_PROJECT,
			PROJECTS
		}
	},
	components: {
		CrossDockDashboard,
		ControlTowerDashboard
	},
	created() {
		const user = getLoggedInUser()
        this.project = getUsersProject(user)
	}
}

</script>